// Which answers must be cleared when From-Center mode is switched OFF.
//
// Kevin, 2026-09-02, asked for exactly this: "they should clear."
//
// WHY THERE IS ANYTHING TO CLEAR. From-Center mode is what REVEALS the IN and FROM_CENTER
// rows -- NetSuite's own hide rules gate both on an inlet being Firetube, and Group.tsx
// force-shows them while the mode is on. Switching the mode off hides them again, and the
// values stay in the answer model. The description operation then prints them anyway: its
// qtVal() suppresses blank and None and has no notion of visibility.
//
// That is how HCL-SB26/18-12-3 came to say `4" In` on both Main and Option 3. The 4" had
// been entered as `4" Right of Center` -- a distance from the firetube centre -- and
// dropping FROM_CENTER re-datumed it to the edge without changing the number. Same number,
// different hole, no warning. Clearing forces the distance to be re-entered against the
// datum that is now in force.
//
// BOTH ROWS, not just the distance. They are revealed together and hidden together, and a
// surviving FROM_CENTER leaks on its own: dir1Parts() prints a bare "Right of Center" when
// the side outlives its distance.
//
// Answer keys are "QUESTION/ANSWER" (e.g. "IN/MAIN_1"), so this reads the live model rather
// than a hardcoded inlet list -- a sixth inlet column would be covered the day it exists.
const CLEAR_ON_OFF = new Set(["IN", "FROM_CENTER"]);

/** The [question, answerCode] pairs to set to null. Empty when there is nothing to clear. */
export function directionOneKeysToClear(
  answers: Record<string, unknown>
): Array<[string, string]> {
  const out: Array<[string, string]> = [];
  for (const key of Object.keys(answers || {})) {
    const cut = key.indexOf("/");
    // A key with no separator, or one starting with it, addresses no answer slot.
    if (cut <= 0) continue;
    const question = key.slice(0, cut);
    if (!CLEAR_ON_OFF.has(question)) continue;
    const answer = key.slice(cut + 1);
    if (!answer) continue;
    out.push([question, answer]);
  }
  return out;
}
